export default {
  guide: {
    start: 'Mulai',
    whatsNext: 'Apa selanjutnya?',
    dontShowAgain: 'Jangan tampilkan popup ini lagi',
    needHelp: 'Butuh bantuan?',
    userManual: 'Panduan pengguna',
    chooseFormat: 'Pilih format yang Anda inginkan',
    pdfManual: 'Panduan PDF',
    downloadPdf: 'Unduh dan baca secara offline',
    videoTutorial: 'Tutorial video',
    watchStepByStep: 'Tonton panduan langkah demi langkah',
    firstStepTitle: 'Selamat datang! Kami akan memandu Anda melalui langkah-langkah pertama.',
    activationKey: {
      title: 'Kunci aktivasi baru berhasil didaftarkan.',
      description:
        'Kirimkan kunci aktivasi kepada petani/pengumpul data agar mereka dapat mendaftar di bawah organisasi Anda.',
      nextStep: 'Klik tombol Aksi untuk memilih format yang ingin Anda gunakan untuk membagikan kunci.',
    },
    dashboard: {
      userManagement: 'Manajemen pengguna',
      userManagementDescription: 'Bagian Manajemen pengguna memungkinkan Anda untuk:',
      listUser: 'Melihat daftar pengguna mobile dan admin saat ini',
      addUser: 'Menambahkan pengguna baru atau mengundang pengguna dengan kunci aktivasi',
      managePermission: 'Mengelola izin, paket keanggotaan, dan peran',
      farmManagement: 'Manajemen pertanian',
      farmManagementDescription: 'Buka bagian Manajemen pertanian untuk:',
      listFarm: 'Melihat daftar pertanian dan petani yang terdaftar',
      addFarm: 'Menambahkan pertanian baru satu per satu atau secara massal',
      title: 'Dasbor',
      description:
        'Seiring Anda menambahkan lebih banyak pengguna dan pertanian, Anda akan dapat melihat ringkasan di dasbor utama.',
    },
    ddsDashboard: {
      title: 'Mulai dengan bagian “Buat Laporan Uji Tuntas Baru” untuk memulai.',
      alreadyHaveFarm: 'Sudah memiliki data pertanian?',
      description:
        'Anda akan memiliki opsi untuk menambahkan data pertanian Anda pada langkah kedua dari proses "Buat Laporan Uji Tuntas Baru".',
      createNewReport: 'Buat laporan baru',
      creatingReport: 'Membuat laporan uji tuntas',
      sharingWithOperator: 'Berbagi dengan operator',
      riskMitigation: 'Mitigasi risiko',
    },
    productionPlace: {
      title: 'Unggah data pertanian Anda',
      description: 'Unggah data pertanian Anda satu per satu atau secara massal dengan mengklik tombol "Tambah Baru".',
      allowedFormat: 'Saat ini, kami menerima format berikut untuk unggahan data massal:',
    },
    reportDetail: {
      title: 'Pertama, silakan isi detail terkait laporan Anda.',
      description: 'Butuh bantuan? Lihat panduan pengguna kami (PDF atau video) dengan mengklik di sini:',
      nextStep:
        'Setelah selesai, klik "Berikutnya" untuk melanjutkan ke langkah di mana Anda dapat mengunggah data produksi pertanian Anda.',
    },
    adminRegistered: {
      title: 'Pengguna admin baru berhasil didaftarkan.',
      description:
        'Kirimkan kunci aktivasi kepada petani/pengumpul data agar mereka dapat mendaftar di bawah organisasi Anda.',
      nextStep: 'Apa selanjutnya? Mulai proses pendaftaran petani dan pengumpul data.',
    },
  },
};
